import React, { createContext, useReducer } from 'react';
import messageActions from '../actions/messageActions';
import messageReducer from '../reducers/messageReducer';

export const MessageContext = createContext();

const MessageContextProvider = (props) => {
  const [messageState, dispatch] = useReducer(messageReducer, {
    messageListProgress: false,
    messageListLoaded: false,
    messageListError: null,
    messageList: [],
    messageListIsOld: true,
    messagePostProgress: false,
    messagePostLoaded: false,
    messagePostError: null,
  });
  const actions = messageActions(dispatch);

  return (
    <MessageContext.Provider value={{ messageState, dispatch, actions }}>
      {props.children}
    </MessageContext.Provider>
  );
};

export default MessageContextProvider;
